import { SlotHistoryContent } from '@components/SlotHistory/SlotHistoryContent';
import { SlotHistoryPopin } from '@components/SlotHistory/SlotHistoryPopin';
import { useQueryGetGetSlotHistory } from '@models';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';

import { errorToastConfig } from '../../config/constants';

export const SlotHistory = memo(function SlotHistory({ slotId, onClose }: { slotId: string; onClose: () => void }) {
    const { data: slotHistory } = useQueryGetGetSlotHistory(
        { id: slotId },
        {
            cacheTime: 0,
            onError: () => {
                toast(<FormattedMessage id="slotUpdateHistory.error.retrievalFailed" />, errorToastConfig);
            },
        },
    );

    if (!slotHistory) {
        return null;
    }

    return (
        <SlotHistoryPopin onClose={onClose}>
            <SlotHistoryContent slotHistory={slotHistory} />
        </SlotHistoryPopin>
    );
});
